import React from "react";
import OnlyHeader from "components/Layout/OnlyHeader";
// import AccountSettingTable from "components/AccoutSetting/AccountSettingTable";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";
import { useState } from "react";
import AddSocialProfileModal from "components/Modals/AddSocialProfileModal";
import EditSocialProfileModal from "components/Modals/EditSocialProfileModal";
import { toast } from "react-toastify";
import AccountSettingTable from "components/Settings/AccountSetting/AccountSettingTable";

const AccountSettings = () => {
  const { user } = useSelector((state) => state.auth);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [editData, setEditData] = useState("");
  const [index, setIndex] = useState("");
  const addToggle = () => {
    if (user?.socialProfiles) {
      if (user?.socialProfiles?.length < 5) {
        setAddModal(!addModal);
      } else {
        toast.error("Maximum Limit Reached..!");
      }
    } else {
      setAddModal(!addModal);
    }
  };
  const editToggle = () => {
    setEditModal(!editModal);
  };
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <AccountSettingTable
          data={user?.socialProfiles ? user?.socialProfiles : []}
          addToggle={addToggle}
          editToggle={editToggle}
          deleteToggle={deleteToggle}
          setEditData={setEditData}
          setIndex={setIndex}
        />
      </Container>
      <AddSocialProfileModal addModal={addModal} addToggle={addToggle} />
      <EditSocialProfileModal
        editModal={editModal}
        editToggle={editToggle}
        editData={editData}
        index={index}
      />
    </>
  );
};

export default AccountSettings;
